import Util from "../Util.js";
export default {
  id: 'molten.history.generic.NotExists.ComparatorFilterConverter',
  type: 'generic.NotExists',
  convert: (value, attribute) => {
    const field = Util.getHistoryFieldFromField(attribute.blueprint.field);
    return Util.createSingleComparatorFilter(null, '=', field);
  }
};